'use client'

interface OutlineBtnProps {
  onClick: () => void
  children: React.ReactNode
  className?: string
}

const OutlineBtn = ({ onClick, children, className = '' }: OutlineBtnProps) => {
  return (
    <button
      type='button'
      onClick={onClick}
      className={`text-black py-2 px-3 md:px-5 text-sm font-medium rounded-lg cursor-pointer border border-black ${className}`}
    >
      {children}
    </button>
  )
}

export default OutlineBtn
